import { FC } from 'react';

import { ShowWithTickets } from '~types';

import PurchasePayment from './Payment';
import PurchaseStart from './Start';

export type Route = 'inicio' | 'pago' | 'gracias';

interface Props {
  step: Route;
  show: ShowWithTickets;
}

const PurchaseFlow: FC<Props> = ({ step, show }) => {
  if (!step) return null;
  return (
    <>
      {step === 'inicio' && <PurchaseStart show={show} />}
      <PurchasePayment showTickets={show.ticketPrices} visible={step === 'pago'} show={show} />
    </>
  );
};

export default PurchaseFlow;
